import React from "react";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";
import { Amplify } from "aws-amplify";
import {
  Authenticator,
  ThemeProvider,
  defaultDarkModeOverride,
} from "@aws-amplify/ui-react";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { App } from "antd";
import awsExports from "./aws-exports";
import "./index.css";
import MobileEntryPage from "./MobileEntryPage";
import { BrowserRouter } from "react-router-dom";
import "./Assets/Fonts/Inter-Regular.ttf";
import "./Assets/Fonts/Inter-Medium.ttf";
import "./Assets/Fonts/Inter-SemiBold.ttf";
import "./Assets/Fonts/Inter-Bold.ttf";
import "./Assets/Fonts/Inter-ExtraBold.ttf";
import "./Assets/Fonts/Inter-Black.ttf";
import "./Assets/Fonts/Inter-Light.ttf";
import "./Assets/Fonts/Inter-ExtraLight.ttf";
import "./Assets/Fonts/Inter-Thin.ttf";
import "@mantine/core/styles.css";
import '@mantine/charts/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';
import { MantineProvider } from "@mantine/core";

console.log("NODE_ENV:", process.env.NODE_ENV);
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
  console.info = function () {};
}

Amplify.configure({
  Auth: {
    region: awsExports.REGION,
    userPoolId: awsExports.USER_POOL_ID,
    userPoolWebClientId: awsExports.USER_POOL_APP_CLIENT_ID,
  },
});

const theme = {
  name: "classic-theme",
  tokens: {
    colors: {
      brand: {
        primary: {
          10: { value: "#263cab1a" },
          20: { value: "#263cab33" },
          40: { value: "#263cab66" },
          60: { value: "#263cab99" },
          80: { value: "#263cab" },
          90: { value: "#263cab" },
          100: { value: "#263cab" },
        },
        secondary: {
          10: { value: "{colors.neutral.10}" },
          20: { value: "{colors.neutral.20}" },
          40: { value: "{colors.neutral.40}" },
          60: { value: "{colors.neutral.60}" },
          80: { value: "{colors.neutral.80}" },
          90: { value: "{colors.neutral.90}" },
          100: { value: "{colors.neutral.100}" },
        },
      },
      border: {
        primary: { value: "{colors.neutral.40}" },
        secondary: { value: "{colors.neutral.20}" },
        tertiary: { value: "{colors.neutral.10}" },
      },
    },
    radii: {
      small: { value: "2px" },
      medium: { value: "2px" },
      large: { value: "4px" },
      xl: { value: "6px" },
    },
  },
  overrides: [defaultDarkModeOverride],
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <GoogleOAuthProvider clientId="939028926181-bt6hgb62ofkptc3vhdqhd58ihle6p0kj.apps.googleusercontent.com">
        <ThemeProvider theme={theme}>
          <App>
            <BrowserRouter>
              <Authenticator.Provider>
                <MantineProvider>
                  <MobileEntryPage />
                </MantineProvider>
              </Authenticator.Provider>
            </BrowserRouter>
          </App>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </RecoilRoot>
  </React.StrictMode>
);
